export default __webpack_public_path__ + "static/media/link.78c82f34.svg";